/**
 * Presets de mouvement Framer Motion (spec 05 §2.4).
 * Framer = état d'UI déclaratif ; GSAP = effets impératifs (voir src/effects).
 */
import type { Transition, Variants } from 'motion/react';
import { durations, easings } from '../tokens';

/** Ressorts : `snappy` (tap/feedback), `soft` (modales, pop). */
export const spring = {
  snappy: { type: 'spring', stiffness: 520, damping: 30 } satisfies Transition,
  soft: { type: 'spring', stiffness: 260, damping: 26 } satisfies Transition,
} as const;

/** Tweens : `base` = entrées/sorties UI (240ms, ease fun). */
export const tween = {
  base: { duration: durations.base / 1000, ease: easings.fun } satisfies Transition,
  fast: { duration: durations.fast / 1000, ease: easings.fun } satisfies Transition,
  slow: { duration: durations.slow / 1000, ease: easings.fun } satisfies Transition,
} as const;

/** Apparition douce (opacity + y:8→0). Usage : `variants={fadeInUp}`. */
export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: tween.base },
};

/** Pop ludique (scale .85→1, ressort soft). */
export const popIn: Variants = {
  hidden: { opacity: 0, scale: 0.85 },
  visible: { opacity: 1, scale: 1, transition: spring.soft },
};

/**
 * Conteneur en cascade : anime ses enfants `variants` avec un décalage.
 * Usage : `<motion.ul variants={staggerContainer()} initial="hidden" animate="visible">`.
 */
export const staggerContainer = (stagger = 0.06, delayChildren = 0): Variants => ({
  hidden: {},
  visible: { transition: { staggerChildren: stagger, delayChildren } },
});

/** Secousse douce (erreur de champ, coup manqué). États : `still` / `shake`. */
export const shake: Variants = {
  still: { x: 0 },
  shake: {
    x: [0, -6, 6, -4, 4, 0],
    transition: { duration: 0.4, ease: easings.fun },
  },
};
